import styles from "./Image.module.scss";
import cn from "classnames";
import { ImagePropsI } from "./Image.props";

export default function Image({ src, className, ...props }: ImagePropsI) {
  return (
    <div
      className={cn(styles.img_wrapper, className, {
        [styles.empty]: !src,
      })}
      {...props}
    >
      {src && <img src={src} alt='watt manor' />}
    </div>
  );
}
